import React from 'react'
import Table from '@common/Table'
import store from '../store'
import columns from './column'

export default () => <Table columns={columns} store={store} info={store.info} />
